import { ConfirmDialog } from './ConfirmDialog';
import { Screen } from './kit';

/** Вопрос перед родительским разделом: «А ты точно родитель?».
 *
 *  Решение владельца 2026-09-16: пример (двузначное на однозначное) заменён
 *  вопросом с кнопками «Да» и «Нет». Защитой не было ни то ни другое:
 *  одиннадцатилетний, который тренирует здесь умножение, решал пример так же
 *  легко, как нажмёт «Да». Вопрос останавливает случайное нажатие и
 *  напоминает, что дальше раздел взрослого.
 *
 *  Защита стоит в другом месте, и граница у неё названа. При учётной записи
 *  всё необратимое — удаление ребёнка, выход, удаление учётной записи —
 *  спрашивает пароль у сервера (`PasswordPrompt`). Без учётной записи пароля
 *  нет, и «Удалить навсегда» стоит только за этим вопросом и обычным
 *  подтверждением.
 *
 *  Фокус на «Нет»: Enter вслепую раздел не открывает. «Нет», Esc и нажатие
 *  мимо окна возвращают назад. */
export function ParentGate({ onPass, onBack }: { onPass: () => void; onBack: () => void }) {
  return (
    <Screen>
      <ConfirmDialog
        title="А ты точно родитель?"
        confirmLabel="Да"
        cancelLabel="Нет"
        tone="neutral"
        onConfirm={onPass}
        onCancel={onBack}
      />
    </Screen>
  );
}
